var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 50",
    id: "Copy--Streamline-Block-Free",
    height: 50,
    width: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0 37.5V0h37.5v7.8125l-29.6875 0V37.5H0Z",
    strokeWidth: 3.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M50 12.5H12.5v37.5h37.5V12.5Z",
    strokeWidth: 3.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9c436a8f0d11d9baed4b32bc2dc88285.svg";
export { ForwardRef as ReactComponent };